import {combineReducers} from 'redux';

import searchReducer from './search';
import schoolReducer from './school'
import authReducer from './auth'
import chatReducer from './chat'
import postReducer from './posts'
import leavesReducer from './leaves'
import layoutReducer from './layout';
import searchFacultyReducer from './searchFaculty';

import calendarReducer from './calendar'

const rootReducer = combineReducers({
	auth: authReducer,
	search: searchReducer,
	school: schoolReducer,
	chat: chatReducer,
	posts: postReducer,
	leaves: leavesReducer,
	layout: layoutReducer,
	calendar: calendarReducer,
	searchFaculty: searchFacultyReducer,
});

export default rootReducer;
